import React, { createContext, useState, useEffect, useContext } from 'react';

const AuthContext = createContext();

export const useAuth = () => {
  return useContext(AuthContext);
};

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(!!localStorage.getItem('authToken'));
  const [profile, setProfile] = useState(null);
  const [permissions, setPermissions] = useState([]);

  const isActionAllowed = (screen, actionName) => {
    if (profile?.user_type === 'superadmin') return true;
    const screenPerm = permissions.find(p => p.screen === screen);
    if (!screenPerm) return false;
    if (actionName === 'view') {
      return screenPerm.allowed === true;
    }
    return screenPerm.actions?.some(a => a.action === actionName && a.allowed === true) || false;
  };

  useEffect(() => {
    if (profile) {
      setPermissions(profile?.role_permissions_id?.permissions || []);
    }
  }, [profile]);

  useEffect(() => {
    const token = localStorage.getItem('authToken');
    if (token) {
      setIsAuthenticated(true);
    }
  }, []);

  const login = (token) => {
    localStorage.setItem('authToken', token);
    setIsAuthenticated(true);
  };

  const logout = () => {
    localStorage.removeItem('authToken');
    setIsAuthenticated(false);
  };


  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout, profile, setProfile, permissions, setPermissions, isActionAllowed }}>
      {children}
    </AuthContext.Provider>
  );
};
